// SovEU logo — hand-drawn cloud with motion lines.
// Uses currentColor so it inherits text color (navy on light, white on navy).

export function LogoMark({ size = 28, className = "", title = "SovEU" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      role="img"
      aria-label={title}
      className={className}
    >
      {/* Cloud outline — bumpy top, flat base */}
      <path
        d="M20 40
           C 14 40, 12 34, 16 31
           C 15 25, 22 22, 26 25
           C 28 19, 38 19, 40 25
           C 45 23, 52 27, 50 33
           C 55 34, 55 40, 49 40
           Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Motion lines */}
      <path
        d="M10 45 H 34"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M16 51 H 44"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M24 57 H 50"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Logo({ className = "", size = 44, wordmarkSize = "text-[22px]", showTagline = false }) {
  return (
    <span className={`inline-flex flex-col items-center gap-1 leading-none ${className}`} aria-label="SovEU">
      <LogoMark size={size} />
      <span className={`font-bold tracking-tight ${wordmarkSize}`}>SovEU</span>
      {showTagline && (
        <span className="text-[10px] font-medium tracking-[0.14em] uppercase opacity-70 mt-1">
          Grip op AI. Regie over data.
        </span>
      )}
    </span>
  );
}

export default Logo;
